import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/aevos/Logo";

const MOBILE_MENU_ICON_SIZE = 22;

const NAV = [
  { to: "/", label: "Home" },
  { to: "/sobre", label: "Sobre" },
  { to: "/metodo", label: "Método" },
  { to: "/planos", label: "Planos" },
  { to: "/tecnologia", label: "Tecnologia" },
  { to: "/parcerias", label: "Parcerias" },
  { to: "/contato", label: "Contato" },
];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 border-b border-[#E0E0E0] bg-white/90 backdrop-blur"
      data-testid="site-header"
    >
      <div className="aevos-container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="header-logo">
          <img
            src="/assets/aevos-horizontal.svg"
            alt="AEVOS — Ciência que multiplica vida"
            className="h-8 md:h-9 w-auto"
            draggable={false}
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-2" data-testid="desktop-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `relative font-display text-[0.85rem] font-medium tracking-wide px-3 py-1.5 transition-colors group ${
                  isActive
                    ? "bg-[#00C4FF] text-black"
                    : "text-[#333333] hover:text-black"
                }`
              }
              data-testid={`nav-link-${item.label.toLowerCase()}`}
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {!isActive && (
                    <span className="absolute left-3 right-3 -bottom-0.5 h-[2px] bg-[#00C4FF] origin-left scale-x-0 transition-transform duration-200 group-hover:scale-x-100" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/mapeamento" data-testid="header-quiz-cta">
            <span className="btn-cyan text-[0.78rem]">Mapeamento Online</span>
          </Link>
          <Link to="/contato" data-testid="header-schedule-cta">
            <span className="btn-primary text-[0.78rem]">Agendar Consulta</span>
          </Link>
        </div>

        <button
          className="lg:hidden p-2 text-black"
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={MOBILE_MENU_ICON_SIZE} /> : <Menu size={MOBILE_MENU_ICON_SIZE} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E0E0E0] bg-white" data-testid="mobile-nav">
          <div className="aevos-container py-4 flex flex-col gap-2">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `relative font-display text-base px-3 py-2 transition-colors group inline-block w-fit ${
                    isActive
                      ? "bg-[#00C4FF] text-black font-semibold"
                      : "text-[#333333] hover:text-black"
                  }`
                }
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              >
                {({ isActive }) => (
                  <>
                    {item.label}
                    {!isActive && (
                      <span className="absolute left-3 right-3 -bottom-0.5 h-[2px] bg-[#00C4FF] origin-left scale-x-0 transition-transform duration-200 group-hover:scale-x-100" />
                    )}
                  </>
                )}
              </NavLink>
            ))}
            <div className="flex flex-col gap-2 pt-3">
              <Link to="/mapeamento" onClick={() => setOpen(false)}>
                <span className="btn-cyan w-full justify-center text-[0.85rem]">Mapeamento Online</span>
              </Link>
              <Link to="/contato" onClick={() => setOpen(false)}>
                <span className="btn-primary w-full justify-center text-[0.85rem]">Agendar Consulta</span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
